import { PropsWithChildren } from 'react';

import { FormItemWrapper, InputLabel } from './styled';

interface IItem {
  label: string;
  htmlFor: string;
}

const Item = ({
  children,
  label,
  htmlFor,
  ...rest
}: PropsWithChildren<IItem>) => {
  return (
    <FormItemWrapper {...rest}>
      <InputLabel htmlFor={htmlFor}>{label}</InputLabel>
      {children}
    </FormItemWrapper>
  );
};

export default Item;
